import { PrivateStackParamList } from "@app/navigationApp/types"
import { ThemedView } from "@app/theme";
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { EndJourney } from "../MfdShareLinkInit/components/EndJourney";
import CommonHeader from "@app/sharedComponents/CommonHeader/CommonHeader";

const MfdShareLinkEndJourney = ({
    navigation,
    route
}: NativeStackScreenProps<PrivateStackParamList, 'MFD_SHARE_LINK_END_JOURNEY'>) => {
    return (
        <ThemedView flex={1}>
            <CommonHeader
                label={``}
                navigation={navigation}
                pageName={route.name}
                hideBackButton={true}
            />
            <EndJourney
                navigation={navigation}
                route={route}
            />
        </ThemedView> 
    )
}

export default MfdShareLinkEndJourney;